import './style.scss';

export function locations_block() {
    const block = document.querySelector('.locations_block');
    if (!block) return;


    const tabs = document.querySelectorAll(".location-tab");
    const panels = document.querySelectorAll(".location-panel");
    tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
            const id = tab.dataset.loc;
            tabs.forEach(t => t.classList.remove("active"));
            panels.forEach(p => p.classList.remove("active"));
            tab.classList.add("active");
            const matchedPanels = block.querySelectorAll(`.location-panel[data-panel="${id}"]`);
            matchedPanels.forEach(panel => panel.classList.add("active"));
        });
    });
}

